import { useEffect, useRef } from 'react';
import { initHome } from '../scripts/home';
import CtaSection from '../components/CtaSection';
import HeroSection from './home/HeroSection';
import NeedsSection from './home/NeedsSection';
import UseCasesSection from './home/UseCasesSection';
import PortalsSection from './home/PortalsSection';
import OperationsSection from './home/OperationsSection';
import ProcessSection from './home/ProcessSection';
import ConnectSection from './home/ConnectSection';
import BuilderLabSection from './home/BuilderLabSection';
import FaqSection from './home/FaqSection';

/** 사이트 홈. 섹션별 내용은 ./home/*Section.tsx, 인터랙션은 ../scripts/home.ts */
export default function HomePage() {
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    document.title = 'AcXion-On';
    return rootRef.current ? initHome(rootRef.current) : undefined;
  }, []);

  return (
    <div className="pg-home" ref={rootRef}>
      <HeroSection />
      <NeedsSection />
      <UseCasesSection />
      <PortalsSection />
      <OperationsSection />
      <ProcessSection />
      <ConnectSection />
      <BuilderLabSection />
      <FaqSection />
      <CtaSection />
    </div>
  );
}
